import { TwTheme } from '../../../Tw';

const theme = TwTheme.extend.colors.chart;

export const commonAxisConfig = {
  tickSize: 10,
  tickPadding: 5,
  tickRotation: 0,
  ticksPosition: 'before' as const,
  legendPosition: 'middle' as const,
  legendOffset: 40,
};

export const commonThemeConfig = {
  axis: {
    ticks: {
      text: {
        fontSize: 13,
        fill: theme.ticks,
      },
    },
    legend: {
      text: {
        fontSize: 14,
        fill: theme.legend,
      },
    },
  },
  labels: {
    text: {
      fontSize: 15,
      fill: theme.text,
    },
  },
  grid: {
    line: {
      stroke: theme.grid,
      strokeWidth: 0.3,
    },
  },
  crosshair: {
    line: {
      stroke: theme.crosshair,
      strokeWidth: 3,
      strokeDasharray: '3, 3',
    },
  },
};

export const commonMarginConfig = {
  top: 0,
  right: 20,
  bottom: 50,
  left: 150,
};

